// src/pages/JournalPracticeListPage/index.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Card, Button, Spin } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { getJournalPracticeList } from '../../services/journalService';

const { Title, Text } = Typography;

const JournalPracticeListPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [exerciseIds, setExerciseIds] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);

  useEffect(() => {
    const list = getJournalPracticeList();        // lấy toàn bộ R1-xx
    setExerciseIds(list.map((ex) => ex.id));

    const qCount = list.reduce(
      (sum, ex) => sum + (ex.questions ? ex.questions.length : 0),
      0
    );
    setTotalQuestions(qCount);
    setLoading(false);
  }, []);

  const handleStartRandom = () => {
    if (!exerciseIds.length) return;
    const randomId =
      exerciseIds[Math.floor(Math.random() * exerciseIds.length)];
    // chuyển thẳng tới 1 câu R1-xx ngẫu nhiên
    navigate(`/journal-practice/${randomId}`);
  };

  if (loading) {
    return <Spin size="large" style={{ display: 'block', marginTop: 50 }} />;
  }

  return (
    <div>
      <Title level={2}>仕訳練習リスト</Title>

      <Card style={{ marginTop: 16 }}>
        <Title level={4}>R1：簿記３級 仕訳練習（ランダム）</Title>
        <Text>
          問題セット数：{exerciseIds.length}　／　総問題数：{totalQuestions}
        </Text>
        <br />
        <Text type="secondary">
          ボタンを押すと、R1-01〜R1-30の中から
          ランダムに１問が表示されます。
        </Text>

        <div style={{ marginTop: 24 }}>
          <Button
            type="primary"
            icon={<FileTextOutlined />}
            size="large"
            onClick={handleStartRandom}
          >
            ランダムに練習する
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default JournalPracticeListPage;
